import {Injectable} from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  
  ApiErrorsList = ['BAD_REQUEST', 'CONFLICT', 'BUSINESS_ERROR'];

  handleError(operation = 'operation', error): any {
    if(this.ApiErrorsList.includes(error?.code)) { return error; } 
    const result = {error: {url: '', code: 0, errors: [], message: ''}};
    let err = error?.error ? error.error.error ? error.error.error : error.error : error;
    err = {...error, ...err};

    if (error.status > 0) {
      result.error = err;
      result.error.url = err.url;
      result.error.message = err.message;
    } else {
      result.error = {
        url: operation,
        code: err.status,
        errors: [
          {
            reasons: err.statusText,
          },
        ],
        message: err.statusText,
      };
    }

    return result.error;
  }
}
